const subMenuHandler = () => {
  const menuItem = document.querySelectorAll(".main-nav__list>li");
  menuItem.forEach((el) => {
    el.addEventListener("mouseenter", showSubmenu);
    el.addEventListener("mouseleave", hideSubMenu);
  });

  function showSubmenu() {
    const subMenu = this.querySelector("ul");
    if (subMenu) {
      subMenu.classList.add("visible");
    }
  }

  function hideSubMenu() {
    const subMenu = this.querySelector("ul");
    if (subMenu) {
      subMenu.classList.remove("visible");
    }
  }
};

export { subMenuHandler };
